import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { modalLayer, toastLayer } from '@utils'
import { discountMobx } from 'restaurant'
import { payPlanMobx, memberMobx, payRechargeMobx, thirdPartyMobx } from '@mobxStore'
import { classNames, format } from '@dt/fe-utils'
import { SwitchCardModal } from '@cps'
import { MemberCardAmountModal } from '@pages/checkout/modal'
import CannotPayTip from '../CannotPayTip'
import './index.scss'

const MemberCardPay: FC = () => {
  const totalAmountOffCoupon = payPlanMobx.totalAmount - thirdPartyMobx.couponResult.offPrice
  const handleChangeCard = async (e: any) => {
    if (memberMobx.cardListForPay?.length > 1) {
      await modalLayer(SwitchCardModal, null, 'switchCardModal').then((data: any) => {
        if (!payPlanMobx.memberCardMethod?.amount && data?.balance > 0) {
          handleChangeAmount()
        }
      }).catch(() => { })
    }
  }

  const handleChangeAmount = async (e?: any) => {
    e?.stopPropagation()
    const amounted = await modalLayer<{ card: IMemberCardInfo; fristNum: number }, number>(MemberCardAmountModal, { card: memberMobx.cardInfoForPay, fristNum: totalAmountOffCoupon }, 'memberCardAmountModal')
    payPlanMobx.setMemberCardPayAmount(amounted)
  }

  const changeSelect = async (num, e: any) => {
    e.stopPropagation()
    if (memberMobx.cardInfoForPay?.balance <= 0) return
    if (num > 0) {
      payPlanMobx.setMemberCardPayAmount(0)
    } else {
      handleChangeAmount()
    }
  }

  useEffect(() => {
    // if (payRechargeMobx.memberCardDiscountOnlyBalancePay) {
    // }
    if (payPlanMobx.memberCardMethod?.amount === totalAmountOffCoupon) {
      discountMobx.setOnlyBalancePay(true)
      payPlanMobx.beginCalc()
    } else {
      discountMobx.setOnlyBalancePay(false)
      payPlanMobx.beginCalc()
    }
    if (!thirdPartyMobx.couponResult?.offPrice) {
      toastLayer.info(i18n.t('pay.notMemberCardFullPayTip'))
    }
  }, [payRechargeMobx.memberCardDiscountOnlyBalancePay, payPlanMobx.memberCardMethod?.amount])

  if (!payPlanMobx.memberCardMethod) return null

  return (
    <>
      <div className='member-card-pay' data-cypid='memberCardPay' onClick={handleChangeCard}>
        <i className='iconfont icon-yue' />
        <div className='card-info-member first'>
          <div className='card-name'>
            <span className='card-title'>
              {memberMobx.cardInfoForPay?.card?.cardName || i18n.t('pay.memberCard')}
            </span>
            {window.bo !== 'cn' && <CannotPayTip message={i18n.t(memberMobx.cardInfoForPay?.card?.isPayTip ? 'pay.memberCardGiveBalanceCannotPayTip' : 'pay.memberCardCannotPayTip')} />}
            {memberMobx.cardListForPay?.length > 1 ? <div className='triangle-tip'></div> : ''}
          </div>
          <div className='balance'>
            <span className='balance-price'>
              {i18n.t('pay.cardBalanceN', { n: format.toPrice(memberMobx.cardInfoForPay?.balance) })}
            </span>
            <div className='amount-info'>
              {
                payPlanMobx.memberCardMethod?.amount > 0 ? (
                  <div data-cypid='memberCardPayAmount' onClick={handleChangeAmount}>
                    {format.toPrice(payPlanMobx.memberCardMethod?.amount)}
                  </div>
                ) : ''
              }
            </div>
          </div>
        </div>
        <div className='amount-select' data-cypid='memberCardPaySelect' onClick={(e) => { changeSelect(payPlanMobx.memberCardMethod?.amount, e) }}>
          {
            memberMobx.cardInfoForPay?.balance > 0 ? <i className={classNames('iconfont', (payPlanMobx.memberCardMethod?.amount > 0) ? 'icon-checked' : 'no-select')} /> : <div className='no-checkout'></div>
          }
        </div>
      </div>
    </>
  )
}

export default observer(MemberCardPay)
